import React from "react"

const ConfirmContext = React.createContext()

export const SHOW_CONFIRM = "SHOW_CONFIRM"
export const HIDE_CONFIRM = "HIDE_CONFIRM"

export default ConfirmContext
